import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import './drawer.scss';
import componemtsMaps, { formAuditor, approvalMap, manyPeopleApproval, noHanderActionData, noLeaveOfficeData } from '../examples';
import { getWorkflowNoteInfo } from 'api/flow';
import CommonHeader from '../components/common-header';
import SelectPerson from '../components/select-person';
import ApprovalType from '../components/approval-type';
import { approvalRules } from '../rules';
import Org from '@/components/organization';
export default {
  components: {
    CommonHeader: CommonHeader,
    SelectPerson: SelectPerson,
    ApprovalType: ApprovalType,
    Org: Org
  },
  props: {
    // 组件是否展示
    drawer: {
      default: false,
      type: Boolean
    },
    // 当前节点数据
    nodeData: {
      default: function _default() {
        return {};
      },
      type: Object
    },
    directorLevel: {
      type: Number
    }
  },
  data: function data() {
    return {
      // 循环项
      loopView: ['auditor', 'cc'],
      noHanderActionData: noHanderActionData,
      noLeaveOfficeData: noLeaveOfficeData,
      // 多人审批签字选项
      manyPeopleApproval: manyPeopleApproval,
      // approverVisible: false,
      // Taps下标
      activeName: 'first',
      // Title编辑状态
      isEdit: false,
      // 校验
      rules: approvalRules,
      cEnum: {
        directorLevelPerson: [],
        // 审批人为空指定审批人
        specify_resign: [],
        // 审批人全部离职
        dynamicRadio: []
      },
      isPerson: true,
      form: {
        specify_resign: [],
        settype: 1 // 审批人类型
      }
    };
  },

  computed: {
    // 动态组件切换
    // 根据节点类型展示对应的选项
    dynamicRadio: function dynamicRadio() {
      var _this = this;
      return approvalMap.filter(function (item) {
        return item.type.includes(_this.nodeData.settype);
      });
    }
  },
  created: function created() {
    // 数据拷贝 具体查看数据结构
    var data = JSON.parse(JSON.stringify(this.nodeData));
    this.form = _objectSpread(_objectSpread({}, this.form), data.form);
    this.handleGetWorkflowNoteInfo();
  },
  methods: {
    handleType: function handleType(val, key) {
      if (this.form[val] !== 2) {
        this.form[key] = [];
      }
    },
    /**
     * 切换选项清空值
     * @param { Object } element 当前对象
     */
    handleChangeElement: function handleChangeElement(element) {
      this.$set(element, 'val', '');
    },
    /**
     * 获取下拉选项
     * SetType所选类型
     * @param { number } setType
     */
    getSelectList: function getSelectList(setType) {
      var dynamicRadio = this.cEnum.dynamicRadio;
      var arr = dynamicRadio.filter(function (item) {
        return item.type === setType;
      });
      return arr.length ? arr[0].option : [];
    },
    // 获取组件类型选项（审批人或抄送人）
    handleGetWorkflowNoteInfo: function handleGetWorkflowNoteInfo() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getWorkflowNoteInfo();
            case 2:
              res = _context.sent;
              _this2.cEnum.dynamicRadio = res.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 动态组件切换
    dynamicComponent: function dynamicComponent(type) {
      return componemtsMaps.get(type);
    },
    /**
     * @description 添加条件组
     * @param { string } key 抄送人or审批人
     */
    handlerAddApproval: function handlerAddApproval(key) {
      var addTarget = this.form[key];
      Array.isArray(addTarget) && addTarget.push(formAuditor());
    },
    // 组件关闭操作
    handleClose: function handleClose() {
      this.$emit('update:drawer', false);
    },
    // 删除条件组
    // @parma { Number } i 对应数组的下标
    // @parma { key } 要删除对象的key
    handlerDel: function handlerDel(i, key) {
      this.form[key].splice(i, 1);
    },
    // 保存
    handlerSave: function handlerSave() {
      // 条件组循环校验
      var state = this.$refs.ruleForm.every(function (item) {
        var result = true;
        item.validate(function (valid) {
          return result = valid;
        });
        return result;
      });
      if (this.form.noHanderAction === 2) {
        this.isPerson = !!this.form.directorLevelPerson.length;
      }
      if (this.form.resign_policy === 2) {
        this.isPerson = !!this.form.specify_resign.length;
      }
      // 校验通过
      if (state && this.isPerson) {
        var result = _objectSpread(_objectSpread({}, this.nodeData), {}, {
          form: this.form
        });
        this.$emit('change', result);
        this.handleClose();
      }
    }
  }
};